import { isResourceRequestError } from '@aimmo/ui';

/**
 * The server's own words when it has any, the screen's when it does not.
 *
 * A refusal often carries a message written for the person reading it —
 * "imposta ASSISTANT_KEY_ENCRYPTION_KEY prima di salvare una chiave", a
 * duplicate, a missing consent — and swallowing it behind a generic failure is
 * what turns a five-second fix into a support conversation. Anything without
 * such a message stays generic on purpose: a 500's internals, or a browser's
 * "Failed to fetch", are not for a person.
 */
export function errorMessage(cause: unknown, fallback: string): string {
  return isResourceRequestError(cause) && cause.error.message ? cause.error.message : fallback;
}
